import { render, staticRenderFns } from "./Homesatays.vue?vue&type=template&id=fd81ad02&scoped=true&"
import script from "./Homesatays.vue?vue&type=script&lang=js&"
export * from "./Homesatays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd81ad02",
  null
  
)

export default component.exports